<template>
  <section>
    <!-- 核心服务 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col cols="12" sm="10" md="9" xl="8">
          <div class="core-service">
            <b-tabs content-class="mt-3" class="coreTabs">
              <b-tab
                v-for="(item, index) in tabsData"
                :key="index"
                :title="item.tabsTitle"
                :active="index === 0 ? true : false"
                class="tab-items"
              >
                <!-- <p> -->
                <h3 class="coreServeH3" style="text-align: justify;">{{ item.textTitle }}</h3>
                <p class="coreContext" style="text-align: justify;">{{ item.text }}</p>
                <p class="img">
                  <img :src="item.img" alt="" />
                  <!-- <b-carousel
                    id="carousel-fade"
                    style="text-shadow: 0px 0px 2px #000"
                    controls
                    no-animation
                  >
                    <b-carousel-slide
                      v-for="(imgs, index) in item.img"
                      :key="index"
                      caption=""
                      :img-src="imgs.img"
                    ></b-carousel-slide>
                  </b-carousel> -->
                </p>

                <!-- </p> -->
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        img: require("@/assets/images/e-gov_banner.png"),
        title: "核心服务",
        subTitle: "Core services",
      },
      tabsData: [
        {
          tabsTitle: "云计算",
          textTitle: "民航云签名服务平台",
          text: "共享云签名服务平台，为航司实现电子化签名提供有力支撑。云签名系统在各航司的推广使用，满足了民航局《航空公司基于计算机的记录系统的申请和批准》咨询通告的要求，使得航空公司的飞行员、机组成员、签派员等人员在各阶段训练、检查、考试、体检、资质获取审查等应用场景下，用个人数字证书对记录进行电子签名以确认是本人操作且结果真实有效。业务过程符合《中华人民共和国电子签名法》所使用的数字或电子签名的类型和过程。",
          img: require("@/assets/images/wisdom-gov/cloud.png"),
          // img: [
          //   {
          //     id: "11",
          //     img: require("@/assets/images/e-gov/coreService/qm1.png"),
          //   },
          //   {
          //     id: "12",
          //     img: require("@/assets/images/e-gov/coreService/qm2.png"),
          //   },
          //   {
          //     id: "13",
          //     img: require("@/assets/images/e-gov/coreService/qm3.png"),
          //   },
          //   {
          //     id: "14",
          //     img: require("@/assets/images/e-gov/coreService/qm4.png"),
          //   },
          //   {
          //     id: "15",
          //     img: require("@/assets/images/e-gov/coreService/qm5.png"),
          //   },
          //   {
          //     id: "16",
          //     img: require("@/assets/images/e-gov/coreService/qm6.png"),
          //   },
          //   {
          //     id: "17",
          //     img: require("@/assets/images/e-gov/coreService/qm7.png"),
          //   },
          // ],
        },
        {
          tabsTitle: "合规管理",
          textTitle: "民航企业法定自查系统",
          text:"企业法定自查系统为民航企业进一步落实安全主体责任提供有力保障。截至2021年10月，国航、川航、西部机场集团等13家企业已启用法定自查平台。企业法定自查系统在各机场和航司的推广使用，使得各企业能够根据行业监管事项库，制定单位自查事项清单，建立包括责任人、自查要求、组织方法、发现问题处理程序、自查工作闭环流程和标准等内容在内的自查工作机制，开展自查并做好自查记录备查，实现安全管理从“他律”到“自律”的转变，很好地响应了民航局下发的《关于在全行业推广行业监管模式调整改革的通知》要求。",
          img: require("@/assets/images/wisdom-gov/hggl.png"),
          // img: [
          //   {
          //     id: "21",
          //     img: require("@/assets/images/e-gov/coreService/zc1.png"),
          //   },
          //   {
          //     id: "22",
          //     img: require("@/assets/images/e-gov/coreService/zc2.png"),
          //   },
          //   {
          //     id: "23",
          //     img: require("@/assets/images/e-gov/coreService/zc3.png"),
          //   },
          //   {
          //     id: "24",
          //     img: require("@/assets/images/e-gov/coreService/zc4.png"),
          //   },
          // ],
        },
        {
          tabsTitle: "数据分析",
          textTitle: "航数聚",
          text:"Flight Big Data航数聚是依托信息中心的平台、数据、业务、技术等优势，面向机场行业用户推出的专业化、可视化数据分析解决方案。“航数聚”产品基于信息中心大数据平台，充分发挥大数据资源的底层支撑能力，汇聚融合了航班计划、航班时刻、生产统计、航线收益等航空市场核心数据资源，大幅节省机场数据分析人员的数据处理时间。“航数聚”产品目前已上线31项主功能、116个子项功能组件并持续升级迭代，有机集成了专业BI、可视化大屏、GIS、前端分析组件、微信小程序等各类新技术，以高效、精准、便捷的方式提供一站式、多维度、可定制化的数据分析服务，大幅提高机场数据分析工作效率，为机场(集团)的规划战略、航空运输、数据分析、综合统计等部门用户提供航空运输市场监测、航班计划分析、航班换季分析、运营生产统计、市场规划分析、未来趋势预测等核心数据分析服务。",
          img: require("@/assets/images/wisdom-gov/hsj.png"),
          // img: [
          //   {
          //     id: "21",
          //     img: require("@/assets/images/e-gov/coreService/zc1.png"),
          //   },
          //   {
          //     id: "22",
          //     img: require("@/assets/images/e-gov/coreService/zc2.png"),
          //   },
          //   {
          //     id: "23",
          //     img: require("@/assets/images/e-gov/coreService/zc3.png"),
          //   },
          //   {
          //     id: "24",
          //     img: require("@/assets/images/e-gov/coreService/zc4.png"),
          //   },
          // ],
        },
      ],
    };
  },
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/e-gov_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/e-m.png");
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/core-service.css";
</style>
<style lang="less">
@media (max-width: 575px) {
  .tab-items{
    font-size: 14px;
  }
  .core-service {
    padding-bottom: 50px;
    padding-top: 50px;
    .tab-content.mt-3 {
      /* // padding: 0 50px !important; */
    }
    .coreTabs .nav-tabs {
      .nav-item {
             font-size: 14px;

        a.nav-link {
          padding: 10px 30px;
          font-size: 14px;
        }
      }
    }
   
    .tab-pane {
      padding: 0 40px;
      .coreServeH3 {
        font-size: 15px;
        margin-top: 30px;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
      }
      #carousel-fade {
        height: 200px;
        margin-top: 25px;
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .core-service {
    padding-bottom: 100px;
    padding-top: 50px;
    .coreTabs .nav-tabs {
      .nav-item {
        a {
          padding: 10px 40px;
          font-size: 16px;
        }
      }
    }
    .tab-pane {
      .coreServeH3 {
        font-size: 16px;
        margin-top: 40px;
        margin-bottom: 30px;
      }
      p {
        font-size: 14px;
      }
      #carousel-fade {
        height: 300px;
        margin-top: 35px;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .core-service {
    padding-bottom: 150px;
    padding-top: 60px;
    .coreTabs .nav-tabs {
      .nav-item {
        a {
          padding: 10px 30px;
          font-size: 19px;
        }
      }
    }
    .tab-pane {
      .coreServeH3 {
        font-size: 19px;
        margin-top: 40px;
        margin-bottom: 30px;
      }
      p {
        font-size: 16px;
      }
      #carousel-fade {
        height: 350px;
        margin-top: 40px;
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .core-service {
    padding-bottom: 150px;
    .coreTabs .nav-tabs {
      .nav-item {
        a {
          padding: 10px 50px;
          font-size: 21px;
        }
      }
    }
    .tab-pane {
      .coreServeH3 {
        font-size: 21px;
        margin-top: 40px;
        margin-bottom: 30px;
      }
      p {
        font-size: 18px;
      }
      #carousel-fade {
        height: 450px;
        /* // margin-top: 40px; */
      }
    }
  }
}
@media (min-width: 1200px) {
}
</style>
